<template>
  <div>
    <header @click="toggle" class="section-header">
      <h2 class="tour-description-heading tour-description-heading-detail">
        {{ title }}
        <svgicon v-if="screenWidth <= 640" class="arrow-icon" :class="{ down: expandStatus }" name="arrow-round" />
      </h2>
    </header>
    <transition name="fade">
      <div v-if="expandStatus">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FoldSection',
  props: {
    title: String,
    expand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expandStatus: this.expand || this.onDesktop
    }
  },
  computed: {
    ...mapGetters([
      'screenWidth'
    ]),
    onDesktop () {
      return this.screenWidth > 640
    }
  },
  mounted () {
    this.expandStatus = this.expand || this.onDesktop
  },
  watch: {
    screenWidth (from, to) {
      this.expandStatus = this.expand || this.onDesktop
    }
  },
  methods: {
    toggle() {
      if (this.screenWidth <= 640) {
        this.expandStatus = !this.expandStatus
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.section-header h2 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.arrow-icon {
  margin-left: 16px;
  color: $light-brown;
  width: 16px;
  height: 16px;

  &.down {
    transform: rotate(0.25turn);
  }

  transition: transform 0.3s;
}
</style>